import "../../../style/userInfoKinds.css";

/**
 * A lesson step's *Info to use*, read-only: the names its prompt block reads, in its order. Nothing renders for a step
 * that reads none.
 */
const InfoToUseChips = ({ names, compact = false, style }) => {
  const list = Array.isArray(names) ? names : [];
  if (!list.length) return null;
  return (
    <div
      className={`ui-info-chips${compact ? " ui-info-chips--compact" : ""}`}
      style={style}
      title="Info to use"
      data-testid="info-to-use-chips"
    >
      {list.map((name) => (
        <span key={name} className="ui-info-chip">
          {name}
        </span>
      ))}
    </div>
  );
};

export default InfoToUseChips;
